import { isEmpty } from './is.js';
const nop = Symbol('nopValue');
export function isNop(value) {
    return !isEmpty(value) && !!value[nop];
}
export function isEmptyOrNop(value) {
    return isEmpty(value) || !!value[nop];
}
export function toNop(value) {
    const nopValue = value;
    if (isNop(value)) {
        return value;
    }
    nopValue[nop] = nop;
    return Object.freeze(nopValue);
}
export const nopString = '';
export const nopList = toNop([]);
export const nopMap = toNop(Object.create(null));
//# sourceMappingURL=nop.js.map